// T11 — Activation / login screen.
import { el, mount, typeInto, toast } from "../lib/dom";
import { signInWithEntryCode } from "../lib/firebase";
import { getDeviceId } from "../lib/device";
import { wasBriefed } from "./briefing";
import { go } from "../router";

export async function renderActivation(): Promise<void> {
  const term = el("pre.terminal", {});
  const input = el("input.input", {
    placeholder: "ENTRY CODE",
    autocapitalize: "characters",
    autocomplete: "off",
    maxlength: "8",
  }) as HTMLInputElement;
  const btn = el("button.btn", {}, "Authenticate") as HTMLButtonElement;

  async function submit() {
    const code = input.value.trim();
    if (!code) return;
    btn.disabled = true;
    btn.textContent = "Verifying…";
    try {
      await signInWithEntryCode(code, getDeviceId());
      toast("Access granted, Agent.", "ok");
      go(wasBriefed() ? "/map" : "/briefing");
    } catch (e: unknown) {
      const msg = (e as { message?: string })?.message ?? "Access denied.";
      toast(msg.replace(/^.*?:\s*/, ""), "err");
      btn.disabled = false;
      btn.textContent = "Authenticate";
    }
  }

  btn.addEventListener("click", submit);
  input.addEventListener("keydown", (e) => {
    if ((e as KeyboardEvent).key === "Enter") submit();
  });

  mount(
    el(
      "div",
      {},
      el("div.center", {}, el("h1.amber", {}, "OPERATION"), el("h1", {}, "RIVERGHOST")),
      el("div.card", {},
        el("span.card__tag", {}, "SECURE CHANNEL"),
        term,
        el("div.field", {},
          el("label.tiny", {}, "Credentials"),
          input,
        ),
        btn,
        el("p.tiny.dim.center", { style: "margin-top:14px" }, "Eyes only. Do not share your code."),
      ),
      el("p.center", { style: "margin-top:18px" },
        el("a.tiny.dim", { href: "#/admin", style: "text-decoration:none;letter-spacing:0.1em" }, "· CONTROL access ·")),
    ),
  );

  await typeInto(
    term,
    "CONTROL: Identify yourself, Agent.\nEnter the entry code from your recruitment dossier.",
  );
  input.focus();
}
